import { RoutePath } from '@constants/routes';

export const ACCOUNT_SETTINGS_TABS = [
    {
        label: 'SettingsTabs.profile',
        value: RoutePath.AccountSettingsProfile,
    },
    {
        label: 'SettingsTabs.general',
        value: RoutePath.AccountSettingsGeneral,
    },
    {
        label: 'SettingsGeneral.billing',
        value: RoutePath.AccountSettingsBilling,
    },
    {
        label: 'common.brands',
        value: RoutePath.AccountSettingsBrands,
    },
    {
        label: 'SettingsTabs.channels',
        value: RoutePath.AccountSettingsChannels,
    },
    {
        label: 'common.users',
        value: RoutePath.AccountSettingsUsers,
    },
    {
        label: 'common.teams',
        value: RoutePath.AccountSettingsTeams,
    },
    {
        label: 'SettingsTabs.integrations',
        value: RoutePath.AccountSettingsIntegrations,
    },
];
